import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { IAuthResponseData } from "store/auth/initialState";
import {
  closeDashboardAlertModal,
  openDashboardAlertConfirmationModal,
} from "store/modals";
import Button from "view/components/Button";
import CloseIcon from "../Configuration/CloseIcon";

interface IProps {
  toggleConfigurationModal: () => void;
}

const WelcomeAlert = ({
  toggleConfigurationModal: openConfigurationModal,
}: IProps) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = React.useState(false);
  const { dashboardConfigured } = useSelector<RootState, IAuthResponseData>(
    (state) => state.auth,
  );
  const isWelcomeAlertOpen = useSelector(
    (state: RootState) =>
      state.modals.dashboardAlertConfirmationModal.isWelcomeAlertOpen,
  );

  React.useEffect(() => {
    if (dashboardConfigured || isWelcomeAlertOpen === false) {
      setVisible(false);
      return;
    }

    const timer = window.setTimeout(() => {
      setVisible(true);
    }, 500);

    return () => window.clearTimeout(timer);
  }, [dashboardConfigured, isWelcomeAlertOpen]);

  const handleOpenConfiguration = () => {
    dispatch(closeDashboardAlertModal());
    openConfigurationModal();
  };

  const handleDismiss = () => {
    dispatch(openDashboardAlertConfirmationModal());
  };

  if (dashboardConfigured || !visible) {
    return null;
  }

  return (
    <div className="my-5 w-full dashboard-widget px-4 py-5 rounded-lg bg-bgWhite transition-all dark:bg-secondaryLight dark:border dark:border-lineLight">
      <div className="w-full flex items-center justify-between">
        <div className="w-full flex flex-col mr-2">
          <h6 className="mb-2 text-lg font-semibold leading-6 dark:text-textMain font-Overpass">
            Welcome to your personal dashboard!
          </h6>
          <p className="w-full font-Overpass dark:text-caption text-[13px] font-normal leading-4">
            Click on this widget (or the configurations button) to set up your
            own dashboard, making sure you only see the information that is
            relevant to you!
          </p>
        </div>
        <div className="w-3/4 flex items-center justify-end">
          <Button
            type="button"
            text="Set up my own dashboard"
            filledColor="primary"
            textColor="textWhite"
            className="h-10 p-2 px-5 mr-5 font-semibold hover:bg-primaryMid"
            variant="filled"
            onClick={handleOpenConfiguration}
          />
          <button onClick={handleDismiss}>
            <CloseIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeAlert;
